// extracted by mini-css-extract-plugin
module.exports = {"CopyToClipboard":"CopyToClipboard_CopyToClipboard__jZmzU","icon":"CopyToClipboard_icon___Mfli"};